import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { EntityCard } from "@/components/ui/entity-card";
import { Skeleton } from "@/components/ui/skeleton";
import type { Department, Vehicle, VehicleType } from "../../../api";
import truck from "../../../images/truck.png";
import { useTranslation } from "react-i18next";

export type VehicleDetailsProps = {
    department?: Department;
    vehicle?: Vehicle;
    vehicleType?: VehicleType;
    loading: boolean;
};

export const VehicleDetails = ({
    department,
    vehicle,
    vehicleType,
    loading,
}: VehicleDetailsProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <>
            <CardHeader>
                <CardTitle>{t("component.vehicleDetails.title")}</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-col gap-4">
                <EntityCard
                    vehicle={vehicle}
                    loading={loading}
                    badgeLabel={vehicleType?.label}
                    image={truck}
                />
                <div className="flex justify-between">
                    <div className="text-muted-foreground">
                        {t("component.vehicleDetails.manufacturer")}
                    </div>
                    <div>
                        {!loading &&
                            (vehicle?.manufacturer ?? t("component.vehicleDetails.notConfigured"))}
                        {loading && <Skeleton className="h-full w-24" />}
                    </div>
                </div>
                <div className="flex justify-between">
                    <div className="text-muted-foreground">{t("schema.user.department")}</div>
                    <div>
                        {!loading &&
                            (department?.label ?? t("component.vehicleDetails.notConfigured"))}
                        {loading && <Skeleton className="h-full w-32" />}
                    </div>
                </div>
            </CardContent>
        </>
    );
};
